function contact() {
  $('.js-contact-open').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.js-contact-open').removeClass('is-open');
    $('.contact__answer-inside').removeClass('is-open');

    $(this).addClass('is-open');
    $('#' + tab_id).addClass('is-open');
  });
}
